import React from 'react';
import { common, ScreenProps } from '@fnol/library/src/lib';
import { translations } from '../../lib/consts';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

export const FirstMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', height: 400, paddingTop: '15px' }}>
                <Typography>
                    <h2>{translations.intro.INTRO_MESSAGE_1_TITLE}</h2>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_1}</li>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_2}</li>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_3}</li>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_4}</li>
                        <li>
                            {translations.intro.INTRO_MESSAGE_1_LINE_5_1}
                            <a href={translations.intro.INTRO_MESSAGE_1_LINE_5_LINK_2} target="_blank" rel="noreferrer">
                                {translations.intro.INTRO_MESSAGE_1_LINE_5_2}
                            </a>
                        </li>
                    </ul>
                    <p style={{ fontSize: '1.1rem' }}>{translations.intro.INTRO_MESSAGE_1_REMARK}</p>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <div></div>
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
